<header
  class="flex flex-row items-center justify-between -mt-6 mb-0 -mx-6 px-6 h-20 min-h-20 text-white bg-accent-700"
  mat-dialog-title
  style="overflow: hidden"
>
  <div class="flex flex-row items-center">
    <button [mat-dialog-close]="true" class="close-button" mat-icon-button>
      <mat-icon
        [svgIcon]="'heroicons_solid:chevron-left' | transloco"
        class="close-icon"
      ></mat-icon>
    </button>
    <mat-icon class="icon-size-7 text-current" svgIcon="speaker_notes"></mat-icon>
    <div class="ms-3 text-2xl font-semibold tracking-tight">
      {{ 'add observation' | transloco }}
    </div>
  </div>
</header>
<ng-container>
  <div
    [class.is-loading]="isLoading"
    class="dark w-auto bg-accent-900"
    mat-dialog-content
    style="overflow-x: hidden"
  >
    <!--    <button mat-stroked-button color="primary" style="border-radius: 15px;padding-top: 28px; position: fixed; cursor: pointer; border:none"-->
    <!--            (click)="getBinaryScreenShotFile();"><mat-icon>refresh</mat-icon>-->
    <!--    </button>-->
    <form [formGroup]="observationForm" class="example-form">
      <div class="flex flex-col w-full">
        <div class="mt-3">
          <!--          screen shot and drawing section-->
          <div
            class="w-full sm:p-3 box mb-2 p-2 sm:mt-3 mt-2 flex sm:place-items-center flx-col bg-accent-700 bg-opacity-50"
          >
            <div class="self-center relative" id="screenshot">
              <img
                #screenshot
                alt=""
                class="rounded md:rounded-md"
                id="observationScreenshot"
                src=""
                style="display: none"
              />

              <img
                [src]="screenShotImage"
                alt=""
                class="rounded md:rounded-md"
                style="display: block"
              />
              <input class="hide" id="happy" name="happy" title="Happy" type="checkbox" />
              <canvas
                #screenshot2
                (mousedown)="
                  currentShape === 'Pen' ? setPosition($event) : onCanvasMouseDown($event)
                "
                (mouseenter)="currentShape === 'Pen' ? setPosition($event) : ''"
                (mousemove)="currentShape === 'Pen' ? draw($event) : onCanvasMouseMove($event)"
                (mouseup)="currentShape === 'Pen' ? saveImg($event) : onCanvasMouseUp($event)"
                (touchend)="currentShape === 'Pen' ? saveImg($event) : onCanvasTouchEnd($event)"
                (touchmove)="currentShape === 'Pen' ? draw($event) : onCanvasTouchMove($event)"
                (touchstart)="
                  currentShape === 'Pen' ? setPosition($event) : onCanvasTouchStart($event)
                "
                class="option-happy relative z-20"
                style="border-radius: 5px"
              >
              </canvas>
              <div
                *ngIf="isScreenshotLoading"
                class="absolute inset-0 z-30 flex items-center justify-center bg-black bg-opacity-40 rounded md:rounded-md"
              >
                <mat-spinner diameter="48"></mat-spinner>
              </div>
            </div>
            <div class="flex flex-row justify-center">
              <button
                type="button"
                [matMenuTriggerFor]="shape"
                aria-label="Example icon-button with a menu"
                class="flex flex-row"
                mat-icon-button
              >
                <mat-icon svgIcon="mat_solid:format_shapes"></mat-icon>
              </button>
              <mat-menu #shape="matMenu">
                <button (click)="changeShape(shape)" *ngFor="let shape of shapes" mat-menu-item>
                  {{ shape | transloco }}
                </button>
              </mat-menu>
              <button
                type="button"
                [matMenuTriggerFor]="size"
                aria-label="Example icon-button with a menu"
                class="flex flex-row"
                mat-icon-button
              >
                <mat-icon svgIcon="adjust"></mat-icon>
              </button>
              <mat-menu #size="matMenu">
                <button (click)="changeSize(size)" *ngFor="let size of paintSizes" mat-menu-item>
                  {{ size }}
                </button>
              </mat-menu>

              <button
                type="button"
                [matMenuTriggerFor]="color"
                aria-label="Example icon-button with a menu"
                class="flex flex-row"
                mat-icon-button
              >
                <mat-icon svgIcon="heroicons_solid:color-swatch"></mat-icon>
              </button>
              <mat-menu #color="matMenu">
                <button
                  (click)="changeColor(color.color)"
                  *ngFor="let color of colorArray"
                  mat-menu-item
                >
                  <mat-icon [style.color]="color.color" svgIcon="mat_solid:stop"></mat-icon>
                  {{ color.name }}
                </button>
              </mat-menu>
              <button
                type="button"
                (click)="getBinaryScreenShotFile()"
                aria-label="Example icon-button with a menu"
                class="flex flex-row"
                mat-icon-button
              >
                <mat-icon svgIcon="refresh"></mat-icon>
              </button>
            </div>
          </div>

          <div class="w-auto">
            <mat-form-field class="w-full">
              <mat-label class="text-primary">{{ 'title' | transloco }}</mat-label>
              <input
                [placeholder]="'Write the tittle ...' | transloco"
                formControlName="title"
                matInput
                [maxlength]="titleMaxLength"
              />
              <small class="text-secondary whitespace-nowrap px-1"
                >{{ observationForm.get('title').value?.length || 0 }} / {{ titleMaxLength }}</small
              >
            </mat-form-field>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'description' | transloco }}
              </label>
              <quill-editor
                #descriptionEditor
                [formControlName]="'description'"
                [placeholder]="'Write the description' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'description')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div class="text-sm text-gray-500 mt-1 text-end">
                {{ getDescriptionCharCount() }}/{{ maxQuillEditorsLength }}
                {{ 'characters' | transloco }}
              </div>
            </div>

            <div class="w-full mb-4">
              <label class="text-base font-medium mb-2 block">
                {{ 'Recommended Corrective Action' | transloco }}
              </label>
              <quill-editor
                #recommendedActionEditor
                [formControlName]="'recommended_corrective_action'"
                [placeholder]="'Write the recommended corrective action' | transloco"
                [styles]="{ direction: isArabic() ? 'rtl' : 'ltr' }"
                (onEditorCreated)="onEditorCreated($event, 'recommendedAction')"
                [modules]="quillConfig"
                class="w-full"
              ></quill-editor>
              <div class="text-sm text-gray-500 mt-1 text-end">
                {{ getRecommendedActionCharCount() }}/{{ maxQuillEditorsLength }}
                {{ 'characters' | transloco }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex sm:flex-row flex-col justify-between items-stretch mb-3">
          <div class="w-full">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-category' | transloco }} </mat-label>
              <mat-select
                formControlName="categories"
                (selectionChange)="onCategorySelectionChange()"
                [multiple]="!nwc_client"
                [disabled]="!!observationForm?.get('type') && !observationForm?.get('type')?.value"
              >
                <mat-option
                  (click)="setGoogleEvent('AddNewObservation_selectCatgry_project')"
                  *ngFor="let item of observationCategories"
                  [value]="item.id"
                >
                  {{ item?.category_name_en }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Sub-categories selection -->
          <div class="w-full sm:px-3 px-0" *ngIf="shouldShowSubcategoryField()">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-sub-category' | transloco }} </mat-label>
              <mat-select formControlName="child_categories" [multiple]="!nwc_client">
                <mat-option
                  (click)="setGoogleEvent('AddNewObservation_selectChildCatgry_project')"
                  *ngFor="let item of observationChildCategories"
                  [value]="item.id"
                >
                  {{ item?.category_name_en }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div class="w-full sm:px-3 px-0">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'select-users' | transloco }}</mat-label>
              <mat-select formControlName="users" multiple>
                <mat-option>
                  <ngx-mat-select-search
                    [formControl]="searchControl"
                    [noEntriesFoundLabel]="'No result found' | transloco"
                    [placeholderLabel]="'Search' | transloco"
                  ></ngx-mat-select-search>
                </mat-option>
                <mat-option *ngFor="let member of filteredUsers" [value]="member.uuid">
                  {{ member?.name }}
                  <span class="text-secondary">({{ member.email }})</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div *ngIf="selectedType && isFieldVisible('due_date')" class="w-full sm:px-3 px-0">
            <mat-form-field *ngIf="!checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                (dateChange)="getDate($event.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-dd'"
                [ngxMatDatetimePicker]="picker"
                [placeholder]="'Choose a date' | transloco"
                matInput
                readonly
              />
              <mat-datepicker-toggle [for]="picker" matSuffix> </mat-datepicker-toggle>

              <ngx-mat-datetime-picker #picker (opened)="resetPicker()"> </ngx-mat-datetime-picker>
            </mat-form-field>

            <mat-form-field *ngIf="checkMobile()" appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'Due Date' | transloco }}</mat-label>

              <input
                #dateInput
                (change)="getDate($event.target.value)"
                [formControl]="currentDueDate"
                [min]="minDate | date: 'yyyy-MM-ddThh:mm'"
                [placeholder]="'Choose a date' | transloco"
                matInput
                type="datetime-local"
              />

              <mat-datepicker-toggle (click)="dateInput.click()" matSuffix> </mat-datepicker-toggle>
            </mat-form-field>
          </div>
        </div>
        <div class="grid grid-rows-3 grid-flow-col gap-2 sm:grid-rows-1">
          <div *ngIf="isFieldVisible('significance')">
            <mat-form-field appearance="fill" class="w-full">
              <mat-label class="text-primary">{{ 'significance' | transloco }}</mat-label>
              <mat-select formControlName="significance">
                <mat-option
                  *ngFor="let significance of observationSignificances; index as i"
                  [value]="significance.value"
                >
                  {{
                    i === 0
                      ? ('Select significance' | transloco)
                      : (significance.label | removeUnderscore | titlecase | transloco)
                  }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div *ngIf="isFieldVisible('type')">
            <section class="example-section">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label class="text-primary">{{ 'type' | transloco }} </mat-label>
                <mat-select (selectionChange)="getType($event)" formControlName="type">
                  <mat-option *ngFor="let type of observationTypes" [value]="type.value">
                    {{ type.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </section>
          </div>
          <div *ngIf="isFieldVisible('code')">
            <section class="example-section">
              <mat-form-field appearance="fill" class="w-full">
                <mat-label class="text-primary">{{ 'Code' | transloco }}</mat-label>
                <mat-select formControlName="code">
                  <mat-option
                    *ngFor="let code of observationCodes; index as i"
                    [value]="code.value"
                  >
                    {{ code.label }}
                    <span *ngIf="i !== 0" class="ms-2 text-secondary"
                      >({{ code.description }})</span
                    >
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </section>
          </div>
        </div>

        <!-- Privacy Section -->
        <div *ngIf="isFieldVisible('privacy')">
          <section class="example-section">
            <label>{{ 'privacy' | transloco }}</label
            ><br />
            <div class="text-center">
              <mat-radio-group [color]="'primary'" formControlName="privacy">
                <mat-radio-button
                  (click)="setGoogleEvent('AddNewObservation_PrivacyPublic_project')"
                  class="mt-2"
                  value="public"
                >
                  {{ 'public' | transloco }}
                </mat-radio-button>
                <span class="mx-2"></span>
                <mat-radio-button
                  (click)="setGoogleEvent('AddNewObservation_PrivacyPrivate_project')"
                  class="mx-2"
                  value="private"
                >
                  {{ 'private' | transloco }}
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </section>
        </div>
        <p>add-observation-dialog.component.html</p>

        <div class="w-full mt-3">
          <app-observation-hashtags
            [projectId]="data?.project_id"
            [selectedHashtagsArray]="observationHashtags"
            [isOptional]="true"
            (hashtagsEmitter)="onObservationHashtagsChange($event)"
          ></app-observation-hashtags>
        </div>

        <!-- Custom Fields Section -->
        <app-custom-fields-section
          [customFields$]="customFields$"
          [isLoadingCustomFields$]="isLoadingCustomFields$"
          [form]="observationForm"
          [disabled]="isLoading"
        >
        </app-custom-fields-section>

        <div class="w-full my-3">
          <app-file-uploader
            (filesList)="attachments = $event"
            [multiple]="true"
            [options]="fileOptions"
          >
          </app-file-uploader>
        </div>
      </div>
    </form>

    <div *ngIf="isLoading" class="is-loading-spinner">
      <mat-spinner diameter="60"></mat-spinner>
      <!--<br> {{'loading' | transloco}}...-->
    </div>
  </div>

  <!--  Button Actions section-->
  <mat-dialog-actions align="end" class="actions text-center bg-opacity-20">
    <button mat-button mat-dialog-close>{{ 'cancel' | transloco }}</button>
    <button
      (click)="onSubmit(true)"
      [disabled]="!observationForm.value.title?.trim() || !observationForm.value.type || isLoading"
      mat-raised-button
      class="mx-2"
    >
      {{ 'Save Draft' | transloco }}
    </button>
    <button
      (click)="onSubmit(false)"
      [disabled]="!observationForm.valid || !observationForm.value.title?.trim() || isLoading"
      color="primary"
      mat-raised-button
      type="submit"
    >
      {{ 'Publish' | transloco }}
    </button>
  </mat-dialog-actions>
</ng-container>
